<template>
    <Row :gutter="30">
        <Col :span="field.col || 12" v-for="field in fields" :key="field.key">
        <div class="field">
            <span class="label">{{field.label}}:</span>
            <span class="value">{{data[field.key]}}{{field.desc}}</span>
        </div>
        </Col>
    </Row>
</template>

<script>
export default {
    props: {
        data: Object
    },
    data() {
        return {
            fields: [
                {label: "产权人", key: "estateOwner"},
                {label: "产权人身份证号", key: "estateOwnerId"},
                {label: "不动产号", key: "estateNO"},
                {label: "不动产单元号", key: "estateUnitNO"},
                {label: "楼号", key: "buildingNO"},
                {label: "楼层", key: "layer"},
                {label: "房屋号", key: "houseNO"},
                {label: "房屋属性", key: "houseProperty"},
                {label: "拥有权", key: "possession"},
                {label: "建造时间", key: "buildTime", desc: "年"},
                {label: "规划使用", key: "planningUse", desc: "年"},
                {label: "地址", key: "address", col: 24}
            ]
        }
    },
}
</script>

<style lang="less" scoped>
.field{
    display: flex;
    margin-bottom: 20px;
    .label{
        width: 103px;
        font-weight: bold;
        margin-right: 15px;
        text-align: right;
    }
    .value{
        flex: 1;
    }
}
</style>